import { Table as MantineTable, TableProps } from '@mantine/core';

export type ITableProps = TableProps;

/** @registry Design-layer pass-through over Mantine Table; import this instead of @mantine/core Table outside src/design. Extend here when Table needs house behavior. Compound statics (Table.Thead, Table.Tr, Table.Td, ...) are preserved. */
export const Table = MantineTable;
